module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226187396_04_ill#lot"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226187396_05_int#int"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226187396_06_ch1#ch1"
    }
  }, [_c('em', [_vm._v("1. Muscadins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_07_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Jeunes gens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_08_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Incroyables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_09_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Currutacos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_10_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. Crops")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_11_epi#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_12_ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_13_lis#loa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LIST OF ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_14_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226187396_15_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102c4208","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226187396_03_toc.vue
// module id = 63
// module chunks = 0